import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putControlledProduct } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_PRODS.PUT,
  api: putControlledProduct,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/controlledProducts/PutAction.js